import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { Notifications } from 'components';
import { INotificationsData, INotificationsAction } from 'models/notifications/notifications';
import { IStore } from 'redux/IStore';
import {
	changeTabAndGetRequiredData,
	resetData,
	checkForNewNotifications,
	notificationView,
} from 'modules/notifications/notificationsdropdown';
import { browserHistory } from 'react-router';
import { IUserPreferences } from 'models/user/userpreferences';
import { IShopCard } from 'models/shop/shopcard';
import renderIcon from 'helpers/renderIcon';
import { dropdown, IDropdownProps, closeAllDropdowns } from 'helpers/hooks';
const { connect } = require('react-redux');

interface IProps extends IDropdownProps {
	notificationsDropdown?: INotificationsData;
	userPreferences?: IUserPreferences;

	/* func props */
	t?: (x: string) => string;
	changeTabAndGetRequiredData?: (selectedTab: string) => INotificationsAction;
	resetData?: () => INotificationsAction;
	checkForNewNotifications?: () => INotificationsAction;
	notificationView?: (notificationIds: string[], viewed?: boolean, viewAll?: boolean) => INotificationsAction;
}

@connect(
	(state: IStore) => ({
		notificationsDropdown: state.notificationsDropdown,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		changeTabAndGetRequiredData: (selectedTab: string) => dispatch(changeTabAndGetRequiredData(selectedTab)),
		resetData: () => dispatch(resetData()),
		checkForNewNotifications: () => dispatch(checkForNewNotifications()),
		notificationView: (notificationIds: string[], viewed?: boolean, viewAll?: boolean) =>
			dispatch(notificationView(notificationIds, viewed, viewAll)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
@dropdown()
class NotificationsDropdown extends React.Component<IProps, {}> {
	private intervalID: any;

	constructor(props) {
		super(props);

		this.handleViewAllNotificationsClick = this.handleViewAllNotificationsClick.bind(this);
		this.handleMarkAllAsReadClick = this.handleMarkAllAsReadClick.bind(this);
	}

	public componentDidMount() {
		this.intervalID = setInterval(async () => {
			this.props.checkForNewNotifications();
		}, 300000);
	}

	public componentWillUnmount() {
		clearInterval(this.intervalID);
		this.props.resetData();
	}

	public componentDidUpdate(prevProps: IProps) {
		if (!prevProps.open && this.props.open) {
			this.props.changeTabAndGetRequiredData(this.props.notificationsDropdown.selectedTab);
		}
	}

	private closeModal() {
		this.props.toggle(false);
		this.props.resetData();
	}

	private handleViewAllNotificationsClick(e) {
		e.preventDefault();
		this.props.resetData();
		closeAllDropdowns();
		browserHistory.push('/notifications');
	}

	private handleMarkAllAsReadClick(e) {
		e.preventDefault();
		this.props.notificationView([], true, true);
	}

	public render() {
		const { notificationsDropdown, open, t, userPreferences, toggle } = this.props;

		let shop: IShopCard = null;
		if (userPreferences.userShops && userPreferences.userShops.length > 0) {
			shop = userPreferences.userShops[0];
		}

		return (
			<div className="dropdownHolder notificationsDropdownHolder" ref={this.props.ref1}>
				<a className="iconBtn" title={t('User_NotificationSettings_Title')} onClick={toggle}>
					{renderIcon('notify', undefined, undefined, 'desktopMenuBellIcon')}
				</a>
				<div className="dropdown notificationsDropdown right" style={{ display: open ? 'block' : 'none' }}>
					<div className="dropdownHeader">
						<h4>{t('User_NotificationSettings_Title')}</h4>
						<a className="btnIcon muted" href="#" onClick={() => this.closeModal()}>
							{renderIcon('exit')}
						</a>
					</div>
					<Notifications
						error={notificationsDropdown.error}
						message={notificationsDropdown.message}
						selectedTab={notificationsDropdown.selectedTab}
						items={notificationsDropdown.items}
						itemsPage={{
							currentPage: 1,
							items: notificationsDropdown.items,
							itemsPerPage: 5,
							totalItems: notificationsDropdown.items.length,
							totalPages: 1,
						}}
						changeTabAndGetRequiredData={this.props.changeTabAndGetRequiredData}
						shop={shop}
						onNotificationClick={(id: string) => {
							this.props.notificationView([id], true, false);
						}}
					/>
				</div>
			</div>
		);
	}
}
export { NotificationsDropdown };
